import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { GetStorageComponent, getUserStorageComponent } from '../../utils/storage';
import { UserStoreStateType } from '../../services/user/types';
import * as ROLES from './constants';
import useProfile from '../../hooks/profile/useprofile';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/reducers';
import Loading from '../Loading';
// import ReactGA from 'react-ga';

// ReactGA.pageview(window.location.pathname + window.location.search);

export const PrivateRouteUser = ({ component: Component, ...rest }: any) => {
  const profile = useSelector((state: RootState) => state.profile)

  const { error, loading } = useProfile();
  if ((error || loading) && !profile.id) {
    return error ?
      <div>{`Error :: ${error}`}</div> :
      <Loading pastDelay={true} className="loader-wrap big-loader" />
  }

  const User: UserStoreStateType = getUserStorageComponent('userinfo');
  return (
    <Route
      {...rest}
      render={props => (
        GetStorageComponent('access_token') && User != null ?
          <Component {...props} /> :
          <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )}
    />
  );
};

export const PrivateRouteInstructor = ({ component: Component, ...rest }: any) => {
  const User: UserStoreStateType = getUserStorageComponent('userinfo');
  return (
    <Route
      {...rest}
      render={props => (
        GetStorageComponent('access_token') &&
          User.authorities.length > 0 &&
          User.authorities[0] === ROLES.ROLE_LECTURER ?
          <Component {...props} /> :
          <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )}
    />
  );
};
